import Vue from 'vue';
import resize from 'vue-resize-directive';

Vue.directive('resize', resize);
